import { View, Text, StyleSheet, Dimensions } from 'react-native';
import { LineChart } from 'react-native-gifted-charts';

interface Props {
  data: { value: number; label: string }[];
  title: string;
  minPoints?: number;
}

export function ProgressChart({ data, title, minPoints = 2 }: Props) {
  if (!data || data.length < minPoints) {
    return (
      <View style={styles.empty}>
        <Text style={styles.emptyText}>
          Registre pelo menos {minPoints} medições para ver o gráfico.
        </Text>
      </View>
    );
  }

  // Card: window - 32 (padding lateral do ScrollView pai 16+16). Chart interno: card - 32 (padding do card 16+16) - 50 (yAxis).
  const cardInnerWidth = Dimensions.get('window').width - 32 - 32;
  const chartWidth = Math.max(cardInnerWidth - 50, 200);

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <View style={styles.chartWrapper}>
        <LineChart
          data={data}
          width={chartWidth}
          height={180}
          color="#C8102E"
          thickness={2}
          dataPointsColor="#C8102E"
          xAxisLabelTextStyle={{ color: '#888888', fontSize: 10 }}
          yAxisTextStyle={{ color: '#888888', fontSize: 10 }}
          hideDataPoints={false}
          curved
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { backgroundColor: '#fff', borderRadius: 12, padding: 16, marginBottom: 16, overflow: 'hidden' },
  chartWrapper: { overflow: 'hidden', borderRadius: 6 },
  title: { fontSize: 14, fontWeight: '600', color: '#555', marginBottom: 12 },
  empty: { backgroundColor: '#F5F5F5', borderRadius: 10, padding: 20, alignItems: 'center', marginBottom: 16 },
  emptyText: { color: '#aaa', textAlign: 'center', fontSize: 14 },
});
